// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Request from './request';
import $ from 'jquery';
import rem from './js/rem.js';
import mui from './lib/dist/js/mui.min';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.prototype.mui = mui;
window.moment = require('moment');
//全局时间过滤器
Vue.filter('formatDate', function (value, format) {
  return moment.unix(value).format(format);
});
//全局价格取整过滤器(保留小数点两位)
Vue.filter('numFilter', function (value) {
  let realVal = parseFloat(value).toFixed(2);
  return realVal;
});
//全局价格取整过滤器(小数点后面舍去)
Vue.filter('numFilters', function (value) {
  let realVal = parseFloat(value).toFixed(0);
  return realVal;
});

import "../static/css/mui.min.css";
import {Field,Radio,Checklist,Picker,DatetimePicker,Swipe,SwipeItem,Progress,Lazyload,} from 'mint-ui';
import 'mint-ui/lib/style.css'
import "../static/css/common.css"
import VueScroller from "vue-scroller"

Vue.prototype.$request = Request;
Vue.config.productionTip = false;

/* eslint-disable no-new */
Vue.component(Field.name, Field);
Vue.component(Radio.name, Radio);
Vue.component(Checklist.name, Checklist);
Vue.component(Picker.name, Picker);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Progress.name, Progress);
Vue.use(Lazyload);
Vue.use(VueScroller);

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js